import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
import "moment-timezone";
import React from "react";
import { Button, ControlLabel } from "react-bootstrap";
import shortid from "shortid";
import * as Yup from "yup";
import FormikDatetime from "../../../Shared/FormikDateTime";
import { formats } from "../../../variables/variables";

const AddTimeOffPeriod = ({ add, cancel }) => {
  const minDate = moment().startOf("day");

  const validationSchema = Yup.object().shape({
    description: Yup.string().max(50, "max 50 chars"),
    starts_on: Yup.date()
      .required("is required")
      .min(minDate, "must be on or after today"),
    ends_on: Yup.date()
      .required("is required")
      .min(Yup.ref("starts_on"), "must be on or after the From date"),
  });

  const submitForm = (values, { setSubmitting, setFieldError }) => {
    const startsOn = moment(values.starts_on);
    const endsOn = moment(values.ends_on);
    if (!startsOn.isValid() || !endsOn.isValid()) {
      setFieldError("form", "Both dates must be valid");
      setSubmitting(false);
      return;
    }

    add({
      id: shortid.generate(),
      starts_on: startsOn.format(formats.consistentDateFormat),
      ends_on: endsOn.format(formats.consistentDateFormat),
      description: values.description,
    });

    setSubmitting(false);
  };

  return (
    <div style={{ minWidth: 250 }}>
      <h4>Add Time Off</h4>
      <p style={{ color: "#666", maxWidth: 320 }}>
        Whole days the consultant is away. They will not appear in bookings for this range.
        Regular Hours are kept and resume automatically afterwards.
      </p>

      <Formik
        initialValues={{ starts_on: moment(), ends_on: moment(), description: "" }}
        validationSchema={validationSchema}
        onSubmit={submitForm}
        render={({ errors, touched, isSubmitting, values, setFieldValue, setFieldTouched }) => {
          const hasError = (key) => errors[key] && touched[key] && "has-error";

          return (
            <Form style={{ marginBottom: 20 }}>
              <div className={`form-group ${hasError("starts_on")}`}>
                <ControlLabel>From Date</ControlLabel>
                <FormikDatetime
                  className="datetime-input-small"
                  field="starts_on"
                  input={{
                    value: moment(values.starts_on).format("DD MMM YYYY"),
                    onChange: setFieldValue,
                    onBlur: setFieldTouched,
                  }}
                  closeOnSelect={true}
                  dateFormat="DD MMM YYYY"
                  timeFormat={false}
                />
                <ErrorMessage name="starts_on" component="span" className="help-block" />
              </div>

              <div className={`form-group ${hasError("ends_on")}`}>
                <ControlLabel>To Date</ControlLabel>
                <FormikDatetime
                  className="datetime-input-small"
                  field="ends_on"
                  input={{
                    value: moment(values.ends_on).format("DD MMM YYYY"),
                    onChange: setFieldValue,
                    onBlur: setFieldTouched,
                  }}
                  closeOnSelect={true}
                  dateFormat="DD MMM YYYY"
                  timeFormat={false}
                />
                <ErrorMessage name="ends_on" component="span" className="help-block" />
              </div>

              <div className={`form-group ${hasError("description")}`}>
                <ControlLabel>Description</ControlLabel>
                <Field
                  type="text"
                  name="description"
                  className="form-control form-control-sm"
                />
                <ErrorMessage name="description" component="span" className="help-block" />
              </div>

              <div className={`form-group ${errors["form"] && "has-error"}`}>
                <span className="help-block">{errors && errors["form"]}</span>
              </div>

              <Button onClick={cancel} bsSize="small" className="mr-2">
                Cancel
              </Button>
              <Button disabled={isSubmitting} type="submit" bsStyle="info" bsSize="small">
                Add Time Off
              </Button>
            </Form>
          );
        }}
      />
    </div>
  );
};

export default AddTimeOffPeriod;
